import request from '@/config/axios'

/** 微名片 Admin 用户检索；底层仍走 /bosscircle/lookup（数据共用） */

export interface LookupOption {
  value: number
  label: string
}

export const getUserLookupOptions = (params?: Record<string, any>) =>
  request.get<LookupOption[]>({ url: '/bosscircle/lookup/users', params })
